import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 12l4 -4v8l-4 -4","key":"svg-0"}],["path",{"d":"M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18","key":"svg-1"}]]

/**
 * IconCircleCaretLeft
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2lyY2xlLWNhcmV0LWxlZnQiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTkgMTJsNCAtNHY4bC00IC00IiAvPgogIDxwYXRoIGQ9Ik0xMiAyMWE5IDkgMCAxIDEgMCAtMThhOSA5IDAgMCAxIDAgMTgiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/circle-caret-left
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCircleCaretLeft = createReactComponent('outline', 'circle-caret-left', 'CircleCaretLeft', __iconNode);

export default IconCircleCaretLeft;